// Mock data for WebTech Portfolio

export const mockData = {
  hero: {
    headline: "Building Powerful Websites & Apps That Drive Results",
    subheadline: "Transforming ideas into digital experiences with cutting-edge technology",
    ctaButtons: [
      { text: "View My Work", link: "#projects", primary: true },
      { text: "Hire Me", link: "#contact", primary: false }
    ]
  },
  
  services: [
    {
      id: 1,
      title: "Website Design",
      description: "Custom, responsive websites built with modern technologies and best practices",
      icon: "globe"
    },
    {
      id: 2,
      title: "App Design",
      description: "Native and cross-platform mobile applications with seamless user experiences",
      icon: "smartphone"
    },
    {
      id: 3,
      title: "E-commerce Development",
      description: "Powerful online stores with secure payment integration and inventory management",
      icon: "shopping-cart"
    },
    {
      id: 4,
      title: "UI/UX Design",
      description: "User-centered design solutions that enhance engagement and conversion rates",
      icon: "palette"
    }
  ],
  
  projects: [
    {
      id: 1,
      title: "658 Shopping Solutions",
      description: "A virtual shopping and errand service platform in Jamaica",
      image: "https://customer-assets.emergentagent.com/job_tech-glow-portfolio-1/artifacts/o01mh3z6_19C93BA0-7E33-4E00-A4C8-114377125370.png",
      link: null,
      tags: ["E-commerce", "Web App", "React"]
    },
    {
      id: 2,
      title: "Bird Speed Delivery",
      description: "A fast delivery service platform",
      image: "https://customer-assets.emergentagent.com/job_8719ada7-caea-424b-8eaa-a662dc68aa56/artifacts/z0ukr6xt_IMG_0747.jpeg",
      link: null,
      tags: ["Logistics", "Web Platform", "Real-time"]
    },
    {
      id: 3,
      title: "Elite Trucking Repair",
      description: "A professional truck repair service website built to help customers find services, request assistance, and connect with Elite Trucking Repair.",
      image: "/elite-trucking-repair.svg",
      link: "https://elitetruckingrepair.com",
      tags: ["Truck Repair", "Business Website", "Responsive"]
    }
  ],
  
  about: {
    title: "About WebTech",
    bio: "I'm a full-stack developer specializing in building exceptional digital experiences. With expertise in modern web technologies and a passion for clean, efficient code, I help businesses transform their ideas into powerful, scalable applications. From concept to deployment, I deliver solutions that not only meet technical requirements but exceed user expectations.",
    stats: [
      { label: "Projects Completed", value: "50+" },
      { label: "Years Experience", value: "5+" },
      { label: "Happy Clients", value: "40+" },
      { label: "Technologies", value: "20+" }
    ]
  },
  
  contact: {
    email: "grayj9633@gmail.com",
    phone: "876-484-7978",
    availability: "Available for freelance work"
  },
  
  footer: {
    copyright: "© 2025 WebTech. All rights reserved.",
    tagline: "Building the future, one line of code at a time."
  }
};